(function ($) {
    // 获取当前section的container
    const $container = $(document.currentScript).parent();
    const isMobile = $(window).width() < 1024;

    const $roiContainer = $container.find('[roi-container]');
    const $roiCaseBoxContainer = $container.find('.roi-case-box-container');
    const $roiCaseListContainer = $container.find(isMobile ? '.mo-roi-case-list-container' : '.roi-case-list-container');
    const $mktDrawer = $container.find('.roi-case-dialog-container').get(0);
    const $roiCaseReturnBtn = $container.find('.roi-case-return-btn');
    const $roiCaseCancelBtn = $container.find('.roi-case-cancel-btn');
    const $roiCaseDoneBtn = $container.find('.roi-case-done-btn');
    const $roiCaseList = $container.find('[js-data-case-list]');

    // swiper 相关节点
    const $swiperContainer = $container.find('.swiper');
    const $swiperIndicators = $container.find('[js-indicators]');
    const $emptyText = $container.find('[js-empty-text]');
    const $prevBtn = $roiContainer.find('.mk-indicator-prev');
    const $nextBtn = $roiContainer.find('.mk-indicator-next');
    // 产品选择切换
    const $roiProductSelect = $container.find('[js-roi-product-select]');

    const productsCasesStr = $roiContainer.attr('data-products-cases');


    const sectionStyle = $roiContainer.attr('data-section-style');

    let productsCases = parseJson(productsCasesStr, []).map(normalizeProductCases);

    const $selectCaseBtn = $roiContainer.find('[js-action-select-case]');
    const $customCaseBtn = $roiContainer.find('[js-action-custom-case]');

    let allCaseList = [];
    let currentCases = [];

    let currentProductId = productsCases.length ? productsCases[0].product_id : '';
    let currentProductAllCases = [];

    // 销售价格、成本的步长
    const priceStep = 0.1;
    // 月销量的步长
    const monthlySalesStep = 1;

    let swiperInstance = null; // 添加Swiper实例管理

    getAllCaseList().then(allCases => {
        allCaseList = allCases;
        resetRoiData();
    });

    async function getAllCaseList() {
        const query = `
            query getMetaobjects($cursor: String) {
                metaobjects(type: "roi_case", first: 100, after: $cursor) {
                    edges {
                        node {
                            handle
                            id
                            fields {
                                key
                                value
                                type
                            }
                        }
                    }
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
            }
        `;

        let allEdges = [];
        let cursor = null;
        let hasNextPage = true;

        // 循环查询直到没有下一页
        while (hasNextPage) {
            const variables = {
                cursor: cursor
            };

            const response = await GraphQLHelper.query(query, variables);

            if (response && response.data && response.data.metaobjects) {
                const { edges, pageInfo } = response.data.metaobjects;

                // 合并当前页的数据
                if (edges && edges.length > 0) {
                    allEdges = allEdges.concat(edges);
                }

                // 更新分页信息
                hasNextPage = pageInfo?.hasNextPage || false;
                cursor = pageInfo?.endCursor || null;
            } else {
                // 如果响应格式不正确，停止查询
                hasNextPage = false;
            }
        }

        const allCases = allEdges.map(formatGraphqlCase);

        return allCases;

    }

    function resetRoiData() {
        currentCases = [];
        activeDataList = [];
        currentSelectMap = new Map();
        setCurrentProductAllCases();
        setBestToCurrentCases();
        setSelectCaseBtnStatus();
        initCaseList();
        renderCaseList(currentCases);
    }

    // 根据productId 过滤设置当前产品所有案例
    function setCurrentProductAllCases() {
        currentProductAllCases = currentProductId
            ? allCaseList.filter(item => item.product_list.includes(currentProductId))
            : [];
    }

    function setSelectCaseBtnStatus() {
        if (currentProductAllCases.length === 0) {
            $selectCaseBtn.addClass('select-case-disabled');
        } else {
            $selectCaseBtn.removeClass('select-case-disabled');
        }
    }

    // 设置bestCase 为 currentCases 和 activeDataList
    function setBestToCurrentCases() {
        let bestCases = [];
        // 如果productId 存在，则从productsCases 中获取bestCases
        if (currentProductId) {
            const productCases = productsCases.find(item => normalizeShopifyId(item.product_id) === currentProductId);
            const caseList = Array.isArray(productCases?.case_list) ? normalizeCaseList(productCases.case_list) : [];

            bestCases = caseList.map(caseItem => {
                return allCaseList.find(item => item.id === caseItem.id) || caseItem;
            });
        }
        // 如果配置案例为空，则使用当前产品的前3个案例
        if (bestCases.length === 0) {
            bestCases = currentProductAllCases.slice(0, 3);
        }

        const seenCaseIds = new Set();
        const uniqueBestCases = bestCases.filter(caseItem => {
            const caseId = normalizeShopifyId(caseItem?.id);
            if (!caseId || seenCaseIds.has(caseId)) return false;
            seenCaseIds.add(caseId);
            return true;
        });

        currentCases = uniqueBestCases.map(formatCase);
        activeDataList = uniqueBestCases.map(formatCase);
        currentSelectMap.clear();

    }

    function parseJson(value, fallback) {
        try {
            return JSON.parse(value);
        } catch {
            return fallback;
        }
    }

    function normalizeShopifyId(value) {
        if (value === null || value === undefined) return '';
        const idValue = typeof value === 'object' ? value.id ?? value.value ?? '' : value;
        return String(idValue).trim().split('/').pop();
    }

    function normalizeProductList(productList) {
        const list = typeof productList === 'string' ? parseJson(productList, []) : productList;
        if (!Array.isArray(list)) return [];
        return list.map(normalizeShopifyId).filter(Boolean);
    }

    function normalizeCaseList(caseList) {
        const list = typeof caseList === 'string' ? parseJson(caseList, []) : caseList;
        if (!Array.isArray(list)) return [];
        return list.filter(caseItem => caseItem && typeof caseItem === 'object').map(caseItem => ({
            ...caseItem,
            id: normalizeShopifyId(caseItem.id ?? caseItem.system?.id),
            product_list: normalizeProductList(caseItem.product_list),
        })).filter(caseItem => caseItem.id);
    }

    function normalizeProductCases(productCases) {
        return {
            ...productCases,
            product_id: normalizeShopifyId(productCases?.product_id),
            case_list: normalizeCaseList(productCases?.case_list),
            product_min_price: Number(productCases?.product_min_price) || 0,
        };
    }


    function formatGraphqlCase(caseItem) {
        const { handle, id, fields } = caseItem.node;
        const caseData = fields.reduce((acc, field) => {
            if (field.key === 'product_list') {
                acc.product_list = normalizeProductList(field.value);
            } else {
                acc[field.key] = field.value;
            }
            return acc;
        }, {});
        return formatCase({
            handle,
            id: normalizeShopifyId(id),
            ...caseData,
            product_list: caseData.product_list || [],
        });
    }

    function formatCase(caseItem) {
        caseItem = {
            ...caseItem,
            id: normalizeShopifyId(caseItem?.id ?? caseItem?.system?.id),
            product_list: normalizeProductList(caseItem?.product_list),
        };
        const sale_price = caseItem.sale_price !== undefined ? caseItem.sale_price : caseItem.default_sale_price;
        const cost = caseItem.cost !== undefined ? caseItem.cost : caseItem.default_cost;
        const monthly_sales = caseItem.monthly_sales !== undefined ? caseItem.monthly_sales : caseItem.default_monthly_sales;
        return {
            ...caseItem,
            sale_price: sale_price !== undefined ? Number(sale_price) : undefined,
            cost: cost !== undefined ? Number(cost) : undefined,
            monthly_sales: monthly_sales !== undefined ? Number(monthly_sales) : undefined,
        };
    }

    function renderDeleteBtn() {
        const themeColor = getThemeColor();
        return `
             <div class="mk-delete-btn mk-w-7 mk-h-7 mk-rounded-full ${themeColor.delete_btn} mk-flex mk-items-center mk-justify-center mk-cursor-pointer mk-flex-shrink-0" js-action-delete-case>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6.33333 12C6.14924 12 6 11.8508 6 11.6667V6.33333C6 6.14924 6.14924 6 6.33333 6H6.66667C6.85076 6 7 6.14924 7 6.33333V11.6667C7 11.8508 6.85076 12 6.66667 12H6.33333Z" fill="currentColor"/>
                    <path d="M9.33333 6C9.14924 6 9 6.14924 9 6.33333V11.6667C9 11.8508 9.14924 12 9.33333 12H9.66667C9.85076 12 10 11.8508 10 11.6667V6.33333C10 6.14924 9.85076 6 9.66667 6H9.33333Z" fill="currentColor"/>
                    <path d="M10.5 3H13.6667C13.8508 3 14 3.14924 14 3.33333V3.66667C14 3.85076 13.8508 4 13.6667 4H13V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V4H2.33333C2.14924 4 2 3.85076 2 3.66667V3.33333C2 3.14924 2.14924 3 2.33333 3H5.5L5.5 1.8C5.5 1.35817 5.85817 1 6.3 1H9.7C10.1418 1 10.5 1.35817 10.5 1.8V3ZM6.5 3H9.5L9.5 2L6.5 2V3ZM4 4V14H12V4H4Z" fill="currentColor"/>
                </svg>
            </div>
        `;
    }

    function getThemeColor() {
        let themeColor = {};
        if (sectionStyle === 'white') {
            themeColor = {
                case_box: 'mk-bg-[#FFF] mk-text-[#000000E0]',
                label_color: 'mk-text-[#000000A6]',
                delete_btn: 'mk-bg-[#F2F3F5] mk-text-[#1F1F1F]',
                input: 'mk-bg-[#FFF] mk-text-[#000000E0] mk-border-[#0505050F] focus:mk-bg-[#FFF] focus:mk-text-[#000000E0] focus:mk-border-[#0505050F]',
                progress_bg: "#ECEDF0",
                progress_active_bg: "#1677FF",
                empty_text: 'mk-text-[#00000040]',
                divider_color: '#0505050F'
            };
        } else {
            themeColor = {
                case_box: 'mk-bg-[#262626] mk-text-[#FFFFFFF5]',
                label_color: 'mk-text-[#FFFFFFA6]',
                delete_btn: 'mk-bg-[#FDFDFD29] mk-text-[#FFF]',
                input: 'mk-bg-[#262626] mk-text-[#FFFFFFF5] mk-border-[#595959] focus:mk-bg-[#262626] focus:mk-text-[#FFFFFFF5] focus:mk-border-[#595959]',
                progress_bg: "#434343",
                progress_active_bg: "#1677FF",
                empty_text: 'mk-text-[#FFFFFF40]',
                divider_color: '#FDFDFD29'
            };
        }
        return themeColor;
    }

    // 获取input range 的背景色
    function getInputRangeBackgroundColor(percent) {
        const themeColor = getThemeColor();
        return `linear-gradient(to right, ${themeColor.progress_active_bg} ${percent}%, ${themeColor.progress_bg} ${percent}%)`;
    }

    function renderCaseList(list) {
        let html = '';

        const themeColor = getThemeColor();
        if (list.length === 0) {
            $emptyText.removeClass('mk-hidden').addClass('mk-flex');
            $roiCaseList.html('');
            handleCalculate();
            return;
        } else {
            $emptyText.addClass('mk-hidden').removeClass('mk-flex');
        }

        const isOnlyOneCase = list.length === 1;
        const placeholder = __Xtool_Utils.t('general.roi.placeholder');
        const salePriceLabel = __Xtool_Utils.t('general.roi.sale_price');
        const costLabel = __Xtool_Utils.t('general.roi.cost');
        const monthlySalesLabel = __Xtool_Utils.t('general.roi.monthly_sales');
        list.forEach((caseItem, index) => {
            const { sale_price, cost, monthly_sales, default_sale_price, default_cost, default_monthly_sales } = caseItem;

            const isCustomCase = caseItem.type === 'custom';

            const final_sale_price = sale_price !== undefined ? sale_price : default_sale_price;
            const final_cost = cost !== undefined ? cost : default_cost;
            const final_monthly_sales = monthly_sales !== undefined ? monthly_sales : default_monthly_sales;

            const saleSliderPercent = (final_sale_price - caseItem.min_sale_price) / (caseItem.max_sale_price - caseItem.min_sale_price) * 100;
            const costSliderPercent = (final_cost - caseItem.min_cost) / (caseItem.max_cost - caseItem.min_cost) * 100;
            const monthlySalesSliderPercent = (final_monthly_sales - caseItem.min_monthly_sales) / (caseItem.max_monthly_sales - caseItem.min_monthly_sales) * 100;
            html += `
                <div js-roi-case-item class="swiper-slide mk-p-8 mk-rounded-[16px] mobile:mk-flex-shrink-0 mobile:mk-p-4 ${isOnlyOneCase ? 'mobile:mk-flex-1' : ''} ${themeColor.case_box}}  ${isOnlyOneCase ? 'mobile:!mk-mr-0' : ''}" data-index="${index}">
                    <div class="mk-h-[48px] mobile:mk-h-[40px] mk-flex mk-gap-10 mk-items-center mk-justify-between ¥">
                        ${isCustomCase ?
                    `<div class="mk-min-w-0 mk-flex mk-items-center mk-gap-4">
                                <input js-action-custom-case-name-input type="text" placeholder="${placeholder}" class="input-placeholder ${themeColor.input} mk-px-4 mk-py-3 mk-w-[272px] mk-rounded-[8px] mk-text-[14px] mk-font-semibold mk-leading-[18px] mk-mb-0 focus:mk-outline-none" value="${caseItem.name}">
                            </div>`
                    :
                    `<div class="mk-min-w-0 mk-flex mk-items-center mk-gap-4">
                                    ${caseItem.img_url ? `
                                            <div class="mk-case-image mk-w-12 mk-h-12 mk-rounded-[8px] mk-flex mk-items-center mk-justify-center mk-overflow-hidden mobile:mk-w-10 mobile:mk-h-10">
                                                <img src="${caseItem.img_url}" alt="${caseItem.name}" class="mk-w-full mk-h-full">
                                            </div>
                                        ` : ``
                    }  
                                    <div class="mk-flex-1 mk-truncate mk-py-3 mk-font-semibold mk-text-base mk-leading-[1.25]">
                                        ${caseItem.name}
                                    </div>
                            </div>`
                }
                        <div class="mk-case-actions mobile:mk-hidden">
                            ${isOnlyOneCase ? '' : renderDeleteBtn()}
                        </div>
                    </div>
                
                    <div class="mk-case-divider mk-h-[0.5px] mk-bg-[${themeColor.divider_color}] mk-my-4"></div>
                
                    <div class="mk-case-prices mk-flex mk-flex-col mk-gap-6 mobile:mk-gap-4">
                        <div class="mk-price-item mk-h-[38px] mobile:mk-h-[34px]">
                            <div class="mk-price-header mk-flex mk-justify-between mk-items-center ${isCustomCase ? 'mk-h-full' : ''}">
                                <span class="${themeColor.label_color} mk-text-[12px] mk-font-medium mk-leading-[16px]">${salePriceLabel}</span>
                                ${isCustomCase ?
                    `<input
                                        js-action-custom-input-change
                                        data-type="sale_price"
                                        type="number" 
                                        pattern="\d*" 
                                        class="input-placeholder ${themeColor.input} mk-px-4 mk-py-3 mk-w-[62px] mk-text-center mk-rounded-[8px] mk-text-[14px] mk-font-semibold mk-leading-[18px] mk-mb-0 mk-h-full mobile:mk-w-[48px] focus:mk-outline-none" 
                                        value="${final_sale_price}"
                                        step="${priceStep}"
                                        max="${caseItem.max_sale_price}"
                                        min="${caseItem.min_sale_price}"
                                    >`
                    :
                    `<span js-value-sale_price class="mk-text-[{{--title-color}}] mk-text-[18px] mk-font-semibold mk-leading-[22px] mk-text-right mobile:mk-text-[14px] mobile:mk-leading-[18px]">${__Xtool_Utils.formatLocalizedNumber(Number(final_sale_price))}</span>`}
                            </div>
                            <input 
                                js-action-slider-change
                                data-type="sale_price"
                                type="range"
                                class="slider mk-w-full mk-cursor-pointer ${isCustomCase ? 'mk-hidden' : ''}"
                                min="${caseItem.min_sale_price}"
                                max="${caseItem.max_sale_price}"
                                value="${final_sale_price}"
                                step="${priceStep}"
                                style="background: ${getInputRangeBackgroundColor(saleSliderPercent)}"
                            >
                        </div>
                        
                        <div class="mk-price-item mk-h-[38px] mobile:mk-h-[34px]">
                            <div class="mk-price-header mk-flex mk-justify-between mk-items-center ${isCustomCase ? 'mk-h-full' : ''}">
                                <span class="${themeColor.label_color} mk-text-[12px] mk-font-medium mk-leading-[16px]">${costLabel}</span>
                                ${isCustomCase ?
                    `<input
                                        js-action-custom-input-change
                                        data-type="cost"
                                        type="number"
                                        pattern="\d*"
                                        class="input-placeholder ${themeColor.input} mk-px-4 mk-py-3 mk-w-[62px] mk-text-center mk-rounded-[8px] mk-text-[14px] mk-font-semibold mk-leading-[18px] mk-mb-0 mk-h-full mobile:mk-w-[48px] mobile:mk-h-full focus:mk-outline-none"
                                        value="${final_cost}"
                                        step="${priceStep}"
                                        max="${caseItem.max_cost}"
                                        min="${caseItem.min_cost}"
                                    >`
                    :
                    `<span js-value-cost class="mk-text-[18px] mk-font-semibold mk-leading-[22px] mk-text-right mobile:mk-text-[14px] mobile:mk-leading-[18px]">${__Xtool_Utils.formatLocalizedNumber(Number(final_cost))}</span>`
                }
                            </div>
                            <input 
                                js-action-slider-change
                                data-type="cost"
                                type="range"
                                class="slider mk-w-full mk-cursor-pointer ${isCustomCase ? 'mk-hidden' : ''}"
                                min="${caseItem.min_cost}"
                                max="${caseItem.max_cost}"
                                value="${final_cost}"
                                step="${priceStep}"
                                style="background: ${getInputRangeBackgroundColor(costSliderPercent)}"
                            >
                        </div>
                    
                        <div class="mk-price-item mk-h-[38px] mobile:mk-h-[34px]">
                            <div class="mk-price-header mk-flex mk-justify-between mk-items-center ${isCustomCase ? 'mk-h-full' : ''}">
                                    <span class="${themeColor.label_color} mk-text-[12px] mk-font-medium mk-leading-[16px]">${monthlySalesLabel}</span>
                                ${caseItem.type === 'custom' ?
                    `<input
                                        js-action-custom-input-change
                                        data-type="monthly_sales"
                                        type="number"
                                        pattern="\d*"
                                        class="input-placeholder ${themeColor.input} mk-px-4 mk-py-3 mk-w-[62px] mk-text-center mk-rounded-[8px] mk-text-[14px] mk-font-semibold mk-leading-[18px] mk-mb-0 mk-h-full mobile:mk-w-[48px] focus:mk-outline-none"
                                        value="${final_monthly_sales}"
                                        step="${monthlySalesStep}"
                                        max="${caseItem.max_monthly_sales}"
                                        min="${caseItem.min_monthly_sales}"
                                    >`
                    :
                    `<span js-value-monthly_sales class="mk-text-[18px] mk-font-semibold mk-leading-[22px] mk-text-right mobile:mk-text-[14px] mobile:mk-leading-[18px]">${__Xtool_Utils.formatLocalizedNumber(Number(final_monthly_sales))}</span>`
                }
                            </div>
                            <input 
                                js-action-slider-change
                                data-type="monthly_sales"
                                type="range"
                                class="slider mk-w-full mk-cursor-pointer ${isCustomCase ? 'mk-hidden' : ''}"
                                min="${caseItem.min_monthly_sales}"
                                max="${caseItem.max_monthly_sales}"
                                value="${final_monthly_sales}"
                                step="${monthlySalesStep}"
                                style="background: ${getInputRangeBackgroundColor(monthlySalesSliderPercent)}"
                            >
                        </div>
                    </div>
                    <div class="mk-hidden mobile:mk-flex mk-flex-col mk-items-center mk-justify-center mk-mt-4 mk-h-[45px]">
                        ${isOnlyOneCase ? '' :
                    `<div class="mk-flex mk-items-center mk-justify-center mk-w-full mk-h-[0.5px] mk-bg-[${themeColor.divider_color}] mk-mb-4"></div>
                                ${renderDeleteBtn()}
                            `}
                    </div>
                </div>
            `;
        });
        $roiCaseList.html(html);

        updateIndicatorsStatus(list);
        handleCalculate();
    }

    function updateIndicatorsStatus(list) {
        if (list.length > 0) {
            $swiperIndicators.removeClass('mk-hidden');
        } else {
            $swiperIndicators.addClass('mk-hidden');
        }

        if (list.length === 1) {
            $prevBtn.addClass('!mk-hidden');
            $nextBtn.addClass('!mk-hidden');
        } else {
            $prevBtn.removeClass('!mk-hidden');
            $nextBtn.removeClass('!mk-hidden');
        }
    }


    function initSwiper() {
        try {
            swiperInstance = new Swiper($swiperContainer.get(0), {
                loop: false,
                speed: 500,
                spaceBetween: 8,
                slidesPerView: 'auto', // 使用 auto 结合固定宽度来实现左右露出
                centeredSlides: true,
                centerInsufficientSlides: true,
                keyboard: { enabled: true },
                grabCursor: false, // 禁用抓取光标
                pagination: {
                    el: $roiContainer.find('.mk-indicator-pagination')[0],
                    clickable: true,
                    type: 'fraction',
                    formatFractionCurrent: function (number) {
                        return number;
                    },
                    formatFractionTotal: function (number) {
                        return number;
                    },
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="mk-current-index ' + currentClass + '"></span>' +
                            '<span class="mk-mx-1">/</span>' +
                            '<span class="mk-total-count ' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $roiContainer.find('.mk-indicator-next')[0],
                    prevEl: $roiContainer.find('.mk-indicator-prev')[0]
                },
                // 重要：当 slides 动态变化时，自动更新
                observer: true,
                observeParents: true,
                // 完全禁用触摸移动
                allowTouchMove: false
            });
            // 添加事件监听器用于调试和更新自定义指示器
            swiperInstance.on('slideChange', function () {
                updateCustomIndicators(this);
            });

            // 初始化自定义指示器
            updateCustomIndicators(swiperInstance);

        } catch (error) {
            console.error('Failed to initialize Swiper:', error);
        }
    }

    // 更新自定义指示器
    function updateCustomIndicators(swiper) {
        if (!swiper) return;

        const $currentIndex = $roiContainer.find('.mk-current-index');
        const $totalCount = $roiContainer.find('.mk-total-count');

        if ($currentIndex.length && $totalCount.length) {
            // 由于启用了loop，需要计算真实的当前索引
            const realIndex = swiper.realIndex + 1;
            const totalSlides = swiper.slides.length;

            $currentIndex.text(realIndex);
            $totalCount.text(totalSlides);

        }
    }

    function swiperSlideTo(index) {
        if (!swiperInstance) return;
        swiperInstance.slideTo(index);
    }

    function handleSelectCase() {
        if (currentProductAllCases.length === 0) {
            return;
        }
        displayCaseList(true);
    }

    function handleCustomCase() {
        currentCases.unshift({
            type: 'custom',
            id: `custom-${Date.now()}`,
            name: '',
            sale_price: 1,
            cost: 0,
            monthly_sales: 1,
            img_url: '',
            product_price: 1,
            selling_price: 1,
            final_price: 1,
            default_sale_price: 1,
            default_cost: 0,
            default_monthly_sales: 1,
            min_sale_price: 1,
            max_sale_price: 10000,
            min_cost: 1,
            max_cost: 10000,
            min_monthly_sales: 1,
            max_monthly_sales: 10000,
        });
        renderCaseList(currentCases);

        swiperSlideTo(0);
    }

    function handleDeleteCase(e) {
        const $caseItem = $(e.target).closest('[js-roi-case-item]');
        const index = $caseItem.attr('data-index');
        const currentCase = currentCases[index];
        if (currentCase.type === undefined) {
            activeDataList = activeDataList.filter(item => item.id !== currentCase.id && item.type !== 'custom');
        }
        currentCases.splice(index, 1);
        renderCaseList(currentCases);
        swiperSlideTo(index);
    }

    function handleSliderChange(e, inputType) {
        const $input = $(e.target);
        const dataType = $input.attr('data-type');
        const $caseItem = $input.closest('[js-roi-case-item]');
        const index = $caseItem.attr('data-index');
        const inputValue = $input.val();
        let value = inputValue;
        const currentCase = currentCases[index];
        // 销售价格不能小于成本
        if (dataType === 'sale_price') {
            value = Math.max(inputValue, +currentCase.cost + priceStep);
        }
        // 成本不能大于销售价格
        if (dataType === 'cost') {
            value = Math.min(inputValue, +currentCase.sale_price - priceStep);
        }
        // 限制输入值范围, 防止输入值超出范围
        value = Math.max(value, +currentCase[`min_${dataType}`]);
        value = Math.min(value, +currentCase[`max_${dataType}`]);
        currentCases[index][dataType] = value;

        const item = $caseItem.find(`[js-value-${dataType}]`);

        item.text(__Xtool_Utils.formatLocalizedNumber(Number(value))).trigger('change');
        // 更新input 拖动值
        $input.val(value);
        // range 拖动时，更新 input 的 背景色
        if (inputType === 'range') {
            const percent = (value - currentCase[`min_${dataType}`]) / (currentCase[`max_${dataType}`] - currentCase[`min_${dataType}`]) * 100;
            $input.css("background", getInputRangeBackgroundColor(percent));
        }
        handleCalculate();
    }

    function handleCustomCaseNameChange(e) {
        const $input = $(e.target);
        const value = $input.val();
        const $caseItem = $input.closest('[js-roi-case-item]');
        const index = $caseItem.attr('data-index');
        currentCases[index].name = value;
        $input.val(value);
        handleCalculate();
    }

    function addCaseItem(item) {
        return `
        <li class="roi-case-item">
          <div class="mk-relative mk-aspect-square mk-rounded-[8px] mk-overflow-hidden mk-cursor-pointer">
            <img class="mk-w-full mk-h-full mk-object-cover mk-lazy" data-src="${item.img_url}" alt="${item.name}">
            <svg class="roi-case-item-active-icon mk-absolute mk-bottom-1 mk-right-1 mk-hidden" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 19.5C3 20.3284 3.67157 21 4.5 21L19.5 21C20.3284 21 21 20.3284 21 19.5L21 4.5C21 3.67158 20.3284 3 19.5 3H4.5C3.67158 3 3 3.67157 3 4.5V19.5ZM10.5 14.0356L15.8087 8.72699C16.004 8.53173 16.3205 8.53174 16.5158 8.727L16.8694 9.08056C17.0646 9.27582 17.0646 9.5924 16.8694 9.78766L10.8535 15.8033C10.6583 15.9986 10.3417 15.9986 10.1464 15.8034L7.12371 12.7809C6.92844 12.5857 6.92843 12.2691 7.12368 12.0738L7.47722 11.7202C7.67247 11.525 7.98905 11.5249 8.18432 11.7202L10.5 14.0356Z" fill="#1677FF"/>
              <path d="M10.4998 14.0352L15.8086 8.7266C16.0038 8.53134 16.3204 8.53134 16.5157 8.7266L16.8692 9.08016C17.0645 9.27543 17.0645 9.59201 16.8692 9.78727L10.8534 15.803C10.6582 15.9982 10.3416 15.9982 10.1463 15.803L7.12359 12.7805C6.92832 12.5853 6.9283 12.2687 7.12356 12.0734L7.47709 11.7198C7.67235 11.5246 7.98893 11.5246 8.1842 11.7198L10.4998 14.0352Z" fill="white"/>
            </svg>
          </div>
          <div class="mk-font-medium mk-mt-2 mk-text-center mk-leading-none">${item.name}</div>
        </li>
      `;
    }

    // 设置当前选中的案例
    function setActiveCase() {
        $roiCaseListContainer.find('.roi-case-item').each(function () {
            const $this = $(this);
            const $activeIcon = $this.find('.roi-case-item-active-icon');
            $activeIcon.addClass('mk-hidden');
        });
        activeDataList.forEach(function (item) {
            const index = currentProductAllCases.findIndex(function (i) {
                return i.id === item.id;
            });
            const $item = $roiCaseListContainer.find('.roi-case-item').eq(index);
            const $activeIcon = $item.find('.roi-case-item-active-icon');
            $activeIcon.removeClass('mk-hidden');
        });
    }

    function displayCaseList(status) {
        const $backToTopNode = $('.footer-back-to-top');
        const $chatBotNode = $('#x-elephant-chatbot-entrance');
        if (status) {
            activeDataList.forEach(function (item) {
                currentSelectMap.set(item.id, item);
            });
            $roiCaseBoxContainer.removeClass('mk-hidden');
            if (isMobile) {
                $backToTopNode.addClass('!mk-hidden');
                $chatBotNode.addClass('mk-hidden');
                $(document.body).css('overflow', 'hidden');
            } else {
                $roiContainer.addClass('mk-hidden');
            }
            setActiveCase();
        } else {
            currentSelectMap.clear();
            $roiCaseBoxContainer.addClass('mk-hidden');
            $roiContainer.removeClass('mk-hidden');
            if (isMobile) {
                $backToTopNode.removeClass('!mk-hidden');
                $chatBotNode.removeClass('mk-hidden');
                $(document.body).css('overflow', '');
            }
        }
    }

    function initCaseList() {

        const caseListHtml = currentProductAllCases.reduce(function (acc, item) {
            acc += addCaseItem(item);
            return acc;
        }, '');
        let parentNode = $roiCaseListContainer;
        if (isMobile) {
            parentNode = $container.find('.mo-roi-case-list-container');
        }
        parentNode && parentNode.html(caseListHtml);
        document.dispatchEvent(new CustomEvent('custom:loading:update'));
    }

    $roiCaseListContainer.on('click', '.roi-case-item', function () {
        const $this = $(this);
        const $activeIcon = $this.find('.roi-case-item-active-icon');
        const currentIndex = $this.index();
        const data = currentProductAllCases[currentIndex];

        if ($activeIcon.hasClass('mk-hidden')) {
            currentSelectMap.set(data.id, data);
        } else {
            currentSelectMap.delete(data.id);
        }

        $activeIcon.toggleClass('mk-hidden');
    });

    function handleCalculate() {
        const productPrice = getProductPrice(currentProductId);
        $container.get(0).dispatchEvent(new CustomEvent('roi-calculate-change', {
            detail: {
                caseList: currentCases,
                product_min_price: productPrice
            }
        }));
    }

    function getProductPrice(productId) {
        const productCase = productsCases.find(item => normalizeShopifyId(item.product_id) === normalizeShopifyId(productId));
        return Number(productCase?.product_min_price) || 0;
    }

    function handleProductSelectChange(e) {
        const productId = normalizeShopifyId(e.detail ?? e.target.value);
        currentProductId = productId;
        const productCase = productsCases.find(item => normalizeShopifyId(item.product_id) === productId);
        updateProductTitle(productCase?.product_title || e.target.value);
        resetRoiData();
    }

    function handleExternalProductChange(event) {
        const productConfig = event.detail?.productConfig;
        if (productConfig?.product_id) {
            const normalizedProductConfig = normalizeProductCases(productConfig);
            const productId = normalizedProductConfig.product_id;
            productsCases = [normalizedProductConfig];
            currentProductId = productId;
            updateProductTitle(normalizedProductConfig.product_title);
        } else {
            const productId = normalizeShopifyId(event.detail?.productId);
            const productCase = productsCases.find(item => normalizeShopifyId(item.product_id) === productId);
            if (!productCase) return;

            const productOptions = $roiProductSelect.get(0)?.options || [];
            const selectedOption = productOptions.find(option => String(option.value) === productId);
            if (selectedOption) {
                $roiProductSelect.get(0).value = selectedOption.label;
            }
            updateProductTitle(productCase.product_title || selectedOption?.label);

            currentProductId = productId;
        }

        resetRoiData();
        if (isMobile && swiperInstance) {
            swiperInstance.update();
            swiperSlideTo(0);
        }
    }

    function updateProductTitle(title) {
        const nextTitle = String(title ?? '').trim();
        if (!nextTitle) return;
        $container.find('[js-roi-product-title]').text(nextTitle);
    }

    $container.get(0).addEventListener('roi-product-change', handleExternalProductChange);

    function init() {
        // 渲染案例列表
        renderCaseList(currentCases);
        if (isMobile) {
            initSwiper();
            $roiProductSelect.attr('height', '48');
        }
        // 选择案例按钮点击
        $selectCaseBtn.on('click', handleSelectCase);
        // 自定义案例按钮点击
        $customCaseBtn.on('click', handleCustomCase);
        // 删除按钮点击
        $roiCaseList.on('click', '[js-action-delete-case]', handleDeleteCase);

        // 产品选择切换
        $roiProductSelect.on('change', handleProductSelectChange);

        // 滑块输入
        $roiCaseList.on('input', '[js-action-slider-change]', (e) => handleSliderChange(e, 'range'));
        // 自定义案例输入框输入
        // $roiCaseList.on('input', '[js-action-custom-input-change]', (e) => handleSliderChange(e, 'number'));
        // blur 事件
        $roiCaseList.on('blur', '[js-action-custom-input-change]', (e) => handleSliderChange(e, 'number'));
        // 自定义案例名称输入
        $roiCaseList.on('blur', '[js-action-custom-case-name-input]', handleCustomCaseNameChange);
        // 返回按钮点击
        $roiCaseReturnBtn.on('click', function () {
            displayCaseList(false);
        });
        // 取消按钮点击
        $roiCaseCancelBtn.on('click', function () {
            displayCaseList(false);
        });
        $mktDrawer.addEventListener('close', function () {
            displayCaseList(false);
        });
        $roiCaseDoneBtn.on('click', function () {
            activeDataList = Array.from(currentSelectMap.values());

            displayCaseList(false);
            const configCurrentCaseList = currentCases.filter(i => i.type !== 'custom');
            currentCases = currentCases.filter(item => activeDataList.some(i => i.id === item.id) || item.type === 'custom');
            activeDataList.forEach(item => {
                const index = configCurrentCaseList.findIndex(i => i.id === item.id);
                if (index === -1) {
                    currentCases.unshift(item);
                }
            });
            if (currentCases.length === 0) {
                setBestToCurrentCases();
            }
            // 删除当前案例列表中，不在activeDataList中的案例
            renderCaseList(currentCases);

            swiperSlideTo(0);
        });

    }

    theme.AssetsLoader.onPageLoaded(function () {
        // 防止页面加载时，roi-calculate-change 事件触发时，对应监听事件未初始化完成
        setTimeout(() => {
            init();
        }, 500);
    });

})(jQueryTheme);
